export default __webpack_public_path__ + "static/media/bannerBottom.9eed1079.jpg";